module.exports = __webpack_public_path__ + "static/img/gaoxiongyichang.eb1afae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gaoxiongyichang.jpg
// module id = nb4N
// module chunks = 1